/** Real login route in this SPA. `/admin/login` is a leftover URL, not a registered page. */
export const ADMIN_LOGIN_PATH = '/login';

const LEGACY_LOGIN_PATH = '/admin/login';

export function isAdminLoginPath(pathname: string): boolean {
  const pathOnly = pathname.split(/[?#]/)[0];
  return pathOnly === ADMIN_LOGIN_PATH || pathOnly === LEGACY_LOGIN_PATH;
}

/**
 * Post-login destination. Never return a login URL — that is what produced the
 * authenticated "Page Not Found" shell at `/admin/login`.
 */
export function safePostLoginRedirect(from: unknown): string {
  if (typeof from !== 'string' || !from.startsWith('/') || from.startsWith('//')) {
    return '/';
  }

  const pathOnly = from.split(/[?#]/)[0];
  if (isAdminLoginPath(pathOnly)) {
    return '/';
  }

  return from;
}
